__turbopack_context__.v({
  "triggerContent": "rJAApG_triggerContent",
  "triggerContentCollapsed": "rJAApG_triggerContentCollapsed",
  "triggerLabel": "rJAApG_triggerLabel",
});
